module.exports = __webpack_public_path__ + "static/img/23-1.44071ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/23-1.jpg
// module id = Fq/J
// module chunks = 0